<template>
  <v-card data-automationId="post" color="indigo" variant="outlined" class="postItem" @click="goToPost(post.id)">
    <p class="author"><v-icon icon="mdi-account" color="primary"></v-icon> <span data-automationId="postAuthor">{{ post.author }}</span></p>
    <p class="rating"><v-icon data-automationId="postStartButton" :icon="isRated()?'mdi-star':'mdi-star-outline'" color="primary" @click.stop="starClicked"></v-icon><span data-automationId="postRating">{{getStarCount()}}</span></p>
    <h2 data-automationId="postTitle">{{ post.title }}</h2>
    <p data-automationId="postBody">{{ post.body }}</p>
  </v-card>
</template>

<script>

import {getDatabase, ref, update, get} from "firebase/database";

export default {
  props: ['post'],
  methods: {
    goToPost(id) {
      this.$router.push(`/post/${id}`);
    },
    getStarCount(){
      return this.post['starCount'] != undefined ? this.post['starCount']:0;
    },
    isRated(){
      const currentUser = this.$store.getters.currentUser;
      if(this.post.stars != undefined && this.post.stars[currentUser.uid] != undefined){
        return true;
      }
      return false;
    },
    starClicked(){
      const currentUser = this.$store.getters.currentUser;
      var newPost = {...this.post};
      if(newPost.stars == undefined){
        newPost.stars = {};
      }
      if(newPost.stars[currentUser.uid] == undefined || newPost.stars[currentUser.uid] == false){
        newPost.stars[currentUser.uid] = true;
      } else {
        delete newPost.stars[currentUser.uid]
      }
      newPost.starCount=Object.values(newPost.stars).length;
      const db = getDatabase();
      const postRef = ref(db, 'posts/' + this.post.id);
      update(postRef, newPost)
          .then(() => {
            console.log("Post erfolgreich aktualisiert!");
          })
          .catch((error) => {
            console.error("Fehler beim Aktualisieren des Posts:", error);
          });
      let userIdFound = null;
      get(ref(db, 'user-posts')).then((snapshot) => {
        snapshot.forEach((userPostSnapshot) => {
          const userId = userPostSnapshot.key;
          const posts = userPostSnapshot.val();
          if (posts[this.post.id] != undefined) {
            userIdFound = userId;
            // Sobald wir den Benutzer gefunden haben, brechen wir die Schleife ab
            return true; // Beendet die forEach-Schleife, wenn true zurückgegeben wird
          }
        });

        if (userIdFound) {
          const postRef = ref(db, 'user-posts/' + userIdFound);
          var newUserPost = {...this.postRef};
          newUserPost[this.post.id] = newPost;
          update(postRef, newUserPost)
              .then(() => {
                console.log("User-Post erfolgreich aktualisiert!");
              })
              .catch((error) => {
                console.error("Fehler beim Aktualisieren des User-Posts:", error);
              });
        } else {
          console.log("Kein Benutzer gefunden, der dem Post gehört.");
        }
      }).catch((error) => {
        console.error("Fehler beim Durchsuchen der user-posts", error);
      });
      return;
    }
  }
}
</script>

<style scoped>
.postItem{
  padding: 20px;
  margin-bottom: 10px;
}
/* Add styles here to match your design */
</style>
